import http from '../../../../../api/http';

const BASE_URL = '/mypage/jobFair';
const API_URL = `${BASE_URL}/jobNotice`;

// 채용공고 리스트 조회(검색)
function retrieveAllJobNoticePaging(params) {
    return http.post(`${API_URL}/retrieveAllJobNoticePaging`, params)
}

// 채용공고 리스트 조회(특정기업)
function retrieveAllJobNoticeByCorpId(params) {
    return http.post(`${API_URL}/retrieveAllJobNoticeByCorpId`, params)
}

// 채용공고 리스트 조회(특정기업) (재직자/기업 > 상시채용관 현황 > 채용공고 관리 및 입사지원 현황)
function retrieveCorpJobNoticeListPaging(params) {
    return http.post(`${API_URL}/retrieveCorpJobNoticeListPaging`, params)
}
// 채용공고 리스트 조회 (사용자 > 상시채용관 현황 > 관심기업)
function retrieveUserJobNoticeListPaging(params) {
    return http.post(`${API_URL}/retrieveJobNoticeListPaging`, params)
}

// 채용공고 상세 조회
function retrieveJobNotice(jobNoticeSeq) {
    return http.get(`${API_URL}/retrieveJobNotice?jobNoticeSeq=${jobNoticeSeq}`)
}

// 채용공고 등록
function createJobNotice(params) {
    return http.post(`${API_URL}/createJobNotice`, params)
}

// 채용공고 수정
function updateJobNotice(params) {
    return http.post(`${API_URL}/updateJobNotice`, params)
}

// 채용공고 삭제
function deleteJobNotice(params) {
    return http.post(`${API_URL}/deleteJobNotice`, params)
}

export default {
    retrieveAllJobNoticePaging,
    retrieveAllJobNoticeByCorpId,
    retrieveCorpJobNoticeListPaging,
    retrieveUserJobNoticeListPaging,
    retrieveJobNotice,
    createJobNotice,
    updateJobNotice,
    deleteJobNotice,
};